export * from "./validation/";
export * from "./url/";
export { default as client } from "./connected/api";
export * from "./helpers/";
export { default as arrayToMap } from "./arrayToMap";
export { default as messageHelper } from "./messages/messageHelper";

export const dateTimeFormatter = (date) => (
    new Date(date).toISOString()
        .replace("T", " ")
        .split(".")[0]
);

export const dateTimeFormatterISOString = (date) => (
    new Date(date).toISOString()
);

export const formatDateForFilters = (date) => {
    if (typeof date === "string") {
        date = new Date(date);
    }
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    const milliseconds = ('00' + date.getMilliseconds()).slice(-3);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
}